
import wx from 'weixin-js-sdk'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Radio from 'vux/src/components/radio/index.vue'


export default {
name: 'deviceEdit',
components: {
wx,PopupPicker,CheckIcon,XTextarea,Group,Radio
},
data() {
return {
types:[],
type:1,
deviceType:1,
videoCallType:2,
videoCallTypes:[
{key:1,value:'小度视频通话（暂不处理）'},
{key:2,value:'微信音视频通话'},
{key:3,value:'自有 APP 音视频通话'},
],
speakerTypes:[
{key:1,value:'一代'},
{key:2,value:'二代'},
],
lightStationTypes:[
{key:1,value:'公网基站'},
{key:2,value:'局域网基站'},
],
locations:[
{
key:0,
value:'店外（开锁成功播报）'
},
{
key:1,
value:'店内（进店后播报）'
},
],
location:1,
formData:{
id:0,
brand_id:0,
code:'',
title:'',
type:1,
device_type:1,
video_call_type:2,
location:1,
},
}
},
created() {
this.formData.id = Number(this.$route.params.id);
this.formData.brand_id = this.$func.getBrandId();
if(this.formData.id > 0){
this.getDeviceInfo();
}
this.config();
this.loadDeviceTypes();
},
computed:{

},
methods: {
loadDeviceTypes(){
this.$api.deviceType({}).then((res)=>{
if(res){
this.types = res.data.device_type;
this.types.forEach((item)=>{
item.icon = item.img;
item.key = item.type;
item.value = item.title;
if(item.type == 7 && Array.isArray(item.video_call_types) && item.video_call_types.length){
this.videoCallTypes = item.video_call_types.map((callType)=>({
key:Number(callType.type),
value:callType.title,
}));
}
})
console.log(this.types);
}
})
},
changeType(val){
this.formData.type = val;
if(val == 2 || val == 5){
this.formData.device_type = this.formData.device_type || 1;
this.deviceType = this.formData.device_type;
}else if(val == 7){
this.formData.video_call_type = Number(this.formData.video_call_type) || 2;
this.videoCallType = this.formData.video_call_type;
}else{
this.formData.device_type = 1;
this.deviceType = 1;
}
},
changeDeviceType(val){
this.formData.device_type = val;
},
changeVideoCallType(val){
this.formData.video_call_type = Number(val) || 2;
},
changeLocation(val){
this.formData.location = val;
},
getDeviceInfo(){
this.$api.getDeviceInfo({id:this.formData.id}).then((res)=>{
if(res){
let formData = Object.assign({
brand_id: this.$func.getBrandId(),
}, res.data);
delete formData.content;
this.formData = formData;
this.type = res.data.type;
this.deviceType = res.data.device_type || 1;
this.videoCallType = Number(res.data.video_call_type) || 2;
this.location = res.data.location;
console.log('formData',this.formData);
}
})
},
submit() {
if(!this.formData.code){
this.$func.showToast('请输入设备序列号');
return false;
}
if(!this.formData.title){
this.$func.showToast('请输入设备名称');
return false;
}
let formData = Object.assign({}, this.formData);
formData.brand_id = formData.brand_id || this.$func.getBrandId();
delete formData.content;
this.$api.bindDevice(formData).then((res)=>{
if(res.code == 0){
this.$func.showToast('提交成功');
setTimeout(()=>{
this.$router.go(-1);
},300)
}
});
},
scanQRCode(){
let that = this;
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ['qrCode','barCode'],
success: function (res) {
setTimeout(()=>{
let result = that.$func.parseScanResult(res.resultStr);
if(result.indexOf(",") != -1){
result = result.split(',')[1];
}else{
if(result.indexOf('http') != -1 || result.indexOf('/') != -1){
const parts = result.split('/').filter(item => item !== "");
result = parts[parts.length - 1] || result;
}
}
that.formData.code = result;
},300);
}
})
});
wx.error((res)=> {
console.log(res)

})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"scanQRCode"
]
});
}
})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/deviceEdit.vue